export default __webpack_public_path__ + "static/media/IBMPlexSans-Regular-Latin1.edbbba47.woff2";